import { Link } from 'react-router-dom';

/**
 * Real brand shield PNG (transparent, high-res) + typography lock-up.
 * `size` = 'sm' (nav — larger than before), 'md' (footer), 'lg' (hero standalone).
 */
export default function BrandMark({ compact = false, size = 'sm', href = '/' }) {
  // Bigger shield + tighter text pairing matching the original lock-up
  const shieldH =
    size === 'lg' ? 'h-24 md:h-32'
    : size === 'md' ? 'h-16 md:h-20'
    : 'h-12 md:h-14';

  const topLine =
    size === 'lg' ? 'text-2xl md:text-3xl'
    : size === 'md' ? 'text-lg md:text-xl'
    : 'text-[15px] md:text-base';

  const botLine =
    size === 'lg' ? 'text-2xl md:text-3xl'
    : size === 'md' ? 'text-lg md:text-xl'
    : 'text-[15px] md:text-base';

  return (
    <Link
      to={href}
      data-testid="brand-mark-link"
      className="flex items-center gap-3 md:gap-4 group"
      aria-label="Wrongfully Arrested SA — Home"
    >
      <img
        src="/brand-shield-sm.png"
        srcSet="/brand-shield-sm.png 1x, /brand-shield.png 2x"
        alt="Wrongfully Arrested SA shield"
        width="645"
        height="400"
        className={`${shieldH} w-auto object-contain drop-shadow-[0_0_20px_rgba(10,132,255,0.4)] group-hover:drop-shadow-[0_0_28px_rgba(10,132,255,0.6)] transition-[filter,transform] duration-300 group-hover:scale-[1.03]`}
        style={{ imageRendering: 'auto' }}
        draggable={false}
        loading="eager"
        decoding="async"
      />
      {!compact && (
        <span className="flex flex-col leading-[0.98]">
          <span className={`font-poppins font-extrabold text-white ${topLine} tracking-[0.14em] uppercase`}>Wrongfully</span>
          <span className={`font-poppins font-extrabold ${botLine} tracking-[0.14em] uppercase`}>
            <span className="text-[#39A8FF]">Arrested</span> <span className="text-[#FFD400]">SA</span>
          </span>
        </span>
      )}
    </Link>
  );
}
